import React from 'react'
import View from './view'

const VenueHome = ({ ...props }) => {
    return <View {...props} />
}

export default VenueHome
